import { render, staticRenderFns } from "./MenuClassComp.vue?vue&type=template&id=17422cb6&scoped=true&"
import script from "./MenuClassComp.vue?vue&type=script&lang=ts&"
export * from "./MenuClassComp.vue?vue&type=script&lang=ts&"
import style0 from "./MenuClassComp.vue?vue&type=style&index=0&id=17422cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17422cb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VContainer,VFlex,VLayout,VMenu})
